import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Table from '../../../components/Table/Table';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import { createStyles } from '@material-ui/core';

const styles = createStyles({
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: 400,
      lineHeight: 1
    }
  }
});

function TableList(props: any) {
  const { classes } = props;
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>Generated Reports</h4>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={['Supplier name', 'Address', 'Phone No', 'Contact', 'type',  'email', 'last visit' ]}
              tableData={[
                ['FYY Building Contractors', '24, Upper ground, SE1 9PZ', '+44203478596','Jim Jones', 'Building Contractor', 'jim.jones@fyycontract.com', '25-01-2020'],
                ['ATKINS Engineering', 'Unit 6, Highground Industrial Park', '+44734785967', 'John Doe', 'Engineering Consultancy', 'info@atkins.com', '27-03-2020'],
                ['Dynamix Engineering', 'Headoffice, Logic  Park, London', '+44734785967', 'Raj Singh', 'Maintenance Engineer', 'raj.singh@Dynamics.com', '15-07-2020'],
                ['Octagon Maintenance', '50 Liverpool Street, London', '+44734785967', 'Bob Jackson', 'Maintenance Engineer', 'bob.jackson@Octagon.com', '01-07-2020']
              ]}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(styles)(TableList);
